import { type FC } from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Card } from '@wartek-id/card'

import CardPelaksanaan from 'app/KinerjaDinasPage/components/CardPelaksanaan'
import { PENGELOLAAN_KINERJA_KADIN_PATH } from 'app/KinerjaShared/constants/path'
import CardPenetapan from 'app/KinerjaDinasPage/components/CardPenetapan'

type BlockCardProps = {
  showPantauPerencanaan?: boolean
  showPantauPelaksanaan?: boolean
  showPenilaian?: boolean
  showPenetapan?: boolean
}

const BlockCard: FC<BlockCardProps> = ({
  showPantauPerencanaan = false,
  showPantauPelaksanaan = false,
  showPenilaian = false,
  showPenetapan = false,
}) => {
  const bothLeftSide = showPantauPerencanaan && showPantauPelaksanaan
  const hasSides =
    showPantauPerencanaan ||
    showPantauPelaksanaan ||
    showPenetapan ||
    showPenetapan

  if (!hasSides) return null

  return (
    <>
      <div className="grid grid-rows-2 grid-flow-col gap-4 items-stretch">
        {/* Pantau Perencanaan */}
        {showPantauPerencanaan && (
          <Card
            className={clsx('col-span-1', {
              'row-span-1': showPantauPelaksanaan,
              'row-span-2': !showPantauPelaksanaan,
            })}
          >
            <div className="p-6 space-y-3 h-full flex flex-col justify-center">
              <Text variant="heading-lg">Perencanaan Kinerja</Text>

              <div>
                <Button
                  as="a"
                  color="white"
                  size="md"
                  href={`${PENGELOLAAN_KINERJA_KADIN_PATH}/perencanaan`}
                  className="!inline-block"
                >
                  Cek
                </Button>
              </div>
            </div>
          </Card>
        )}

        {/* Pantau Pelaksanaan */}
        {showPantauPelaksanaan && (
          <Card
            className={clsx('col-span-1', {
              'row-span-1': showPantauPerencanaan,
              'row-span-2': !showPantauPerencanaan,
            })}
          >
            <div className="p-6 space-y-3 h-full flex flex-col justify-center">
              <Text variant="heading-lg">Pelaksanaan Kinerja</Text>

              <div>
                <Button
                  as="a"
                  color="white"
                  size="md"
                  href={`${PENGELOLAAN_KINERJA_KADIN_PATH}/pelaksanaan`}
                  className="!inline-block"
                >
                  Cek
                </Button>
              </div>
            </div>
          </Card>
        )}

        {/* Penilaian Kinerja Pegawai */}
        {showPenilaian && (
          <CardPelaksanaan
            vertical={!showPenetapan && bothLeftSide}
            className={clsx('col-span-3', {
              'row-span-1': showPenetapan,
              'row-span-2': !showPenetapan,
            })}
          />
        )}

        {/* Penetapan Predikat Pegawai */}
        {showPenetapan && (
          <CardPenetapan
            vertical={!showPenilaian && bothLeftSide}
            className={clsx('col-span-3', {
              'row-span-1': showPenilaian,
              'row-span-2': !showPenilaian,
            })}
          />
        )}
      </div>
    </>
  )
}
export default BlockCard
